module.exports = __webpack_public_path__ + "img/pc-dload.c5f50619.png";